var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLikedisabled = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#BFC3CA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1467_828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1467_828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5001 39.9999H21.8334V22.6666L31.1667 13.3333L32.8334 14.9999C32.989 15.1555 33.1167 15.3666 33.2167 15.6333C33.3167 15.8999 33.3667 16.1555 33.3667 16.3999V16.8666L31.9001 22.6666H40.5001C41.2112 22.6666 41.8334 22.9333 42.3667 23.4666C42.9001 23.9999 43.1667 24.6221 43.1667 25.3333V27.9999C43.1667 28.1555 43.1445 28.3221 43.1001 28.4999C43.0556 28.6777 43.0112 28.8444 42.9667 28.9999L38.9667 38.3999C38.7667 38.8444 38.4334 39.2221 37.9667 39.5333C37.5001 39.8444 37.0112 39.9999 36.5001 39.9999ZM24.5001 37.3333H36.5001L40.5001 27.9999V25.3333H28.5001L30.3001 17.9999L24.5001 23.7999V37.3333ZM21.8334 22.6666V25.3333H17.8334V37.3333H21.8334V39.9999H15.1667V22.6666H21.8334Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLikedisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/likedisabled.f8d40996.svg";
export { ForwardRef as ReactComponent };